module.exports = __webpack_public_path__ + "img/2.71dd97b4.png";